// src/pages/ProjectList.js
import React from 'react';
import { Link } from 'react-router-dom';

const ProjectList = () => {
  const projects = [
    { path: '/PrismNews', name: 'Prism News'},
    { path: '/MarcoPollo', name: 'Marco Pollo'},
    { path: '/TwoTierAI', name: 'Organisational AI Strategy: Two Tier AI'},
    { path: '/digital-engineering-hub', name: 'A Digital Engineering Hub' },
    { path: '/CharitySurfEvent', name: 'Log 2 Pint: A Simple Website for a Charity Event' },
    { path: '/DigitalEngineeringTools', name: 'Solving for Today, Scaling for Tomorrow' },
    { path: '/threatening-text', name: 'Threatening Text Detection Model' },
    {
      path: 'https://imagescanai.s3.ap-southeast-2.amazonaws.com/index.html',
      name: 'AI Image Scanner',
      external: true,
    },
    { path: '/Capabilitymatters', name: 'Stop Paying for What You Should Know' },
    { path: '/LessIsMore', name: 'The Best Products Feel Invisible'},
    { path: '/RESTGIS', name: 'REST Assured: Real-Time GIS'},
  ];

  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>Doing + Reflecting</h1>
      <ul>
        {projects.map((project) => (
          <li key={project.name}>
            {project.external ? (
              <a href={project.path} target="_blank" rel="noopener noreferrer">
                {project.name}
              </a>
            ) : (
              <Link to={project.path}>{project.name}</Link>
            )}
          </li>
        ))}
      </ul>
    </main>
  );
};

export default ProjectList;
